export default __webpack_public_path__ + "static/9-8c4f35b62cf95f81f9bee1cdfc849e32.jpg";